var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showWhatsApp)?_c('v-btn',{staticStyle:{"position":"fixed","right":"10px","bottom":"90px"},attrs:{"color":"#25D366","fab":"","large":"","dark":""},on:{"click":_vm.handleSendWhatsApp}},[_c('v-icon',[_vm._v("mdi-whatsapp")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }